import activityLog from './activityLog';

export default activityLog;
